import React from 'react';
import { Link } from 'react-router-dom';
import './MainframeFooter.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-company">
            <div className="company-header">
              <img src="/favicon.png" alt="Spiggl" className="company-logo" />
            </div>
            <p className="mission-statement">find, message, schedule, pay</p>
          </div>
          <div className="footer-legal">
            <div className="legal-title">Legal</div>
            <ul className="footer-links-list">
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>
          <div className="footer-links">
            <div className="footer-links-title">Links</div>
            <ul className="footer-links-list">
              <li><Link to="/support">Support</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/what-is-spiggl">How Spiggl Works</Link></li>
            </ul>
          </div>
          <div className="social-icons">
            <div className="social-title">Socials</div>
            <a href="https://www.tiktok.com/@spiggl" target="_blank" rel="noopener noreferrer">
              <img src="/icons/tik-tok.png" alt="TikTok" className="social-icon" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61574835947167" target="_blank" rel="noopener noreferrer">
              <img src="/icons/facebook.png" alt="facebook" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/spiggl" target="_blank" rel="noopener noreferrer">
              <img src="/icons/instagram.png" alt="Instagram" className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/company/spiggl" target="_blank" rel="noopener noreferrer">
              <img src="/icons/linkedin.png" alt="LinkedIn" className="social-icon" />
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-border"></div>
          <p>© 2026 Spiggl LLC</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;